<template>
	<section class="section --dark --centered small-content-card__section w-95">
		<div class="section__relative">
			<h2 class="small-content-card__title title --uppercase " v-reveal>{{ content.title }}</h2>
			<HighlightableText v-if="content.description" class="description  --mb --limit" v-reveal
				:text="content.description" />
			<Slider v-if="content.slider" :content="content.items" />
			<ul v-else class="small-content-card__list" v-reveal>
				<SmallContentCard v-for="card in content.items" :content="card" :key="card.flexKey" />
			</ul>
		</div>
		<div class="small-content-card__pattern">
			<img v-if="content.background" src="@/assets/patterns/words_pattern_grey.png" alt=""
				class="small-content-card__pattern-image" />
		</div>
	</section>
</template>

<script>
import { HasContentMixin } from '@/mixins'
import { Slider } from '@/components/small'
import { SmallContentCard } from '@/components/cards'
import { HighlightableText } from '@/components/blocks'

export default {
	name: 'SmallContentCardsSection',
	mixins: [HasContentMixin],
	components: { HighlightableText, Slider, SmallContentCard }
}
</script>